import { EventEmitter, Injectable, OnDestroy } from '@angular/core';
import { BaseNotificationService, INotificationItem, INotificationSettingForm } from 'codex-lib';
import { Observable, of, Subscription } from 'rxjs';
import { AnalyticEventClient } from '../enum/analytic-event-client.enum';
import { SignNotificationItem } from '../model/sign-notification-Item';
import { TrackerData } from '../modules/google-analytics/model/tracker-data.model';
import { AnalyticsService } from '../modules/google-analytics/service/analytics.service';
import { NotificationService } from './notification-service';

@Injectable({
  providedIn: 'root',
})
export class CodexNotificationService
  implements BaseNotificationService, OnDestroy {

  notificationsMockArray: INotificationItem[];
  count: Observable<string | number>;
  messageReceiveSubscription: Subscription;

  popupIsOpenChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  private _popupIsOpen: boolean;

  constructor(
    private notificationService: NotificationService,
    private googleAnalitycsService: AnalyticsService) {
    this.refreshTotalUnread();
  }

  public get popupIsOpen(): boolean {
    return this._popupIsOpen;
  }
  public set popupIsOpen(value: boolean) {
    if (this._popupIsOpen === value) {
      return;
    }
    this._popupIsOpen = value;
    this.popupIsOpenChange.next(value);
  }

  ngOnDestroy(): void {
    this.messageReceiveSubscription?.unsubscribe();
  }

  delete(notification: SignNotificationItem): Observable<void> {
    this.refreshNotificationCount();
    return this.notificationService.deleteNotification(notification.id);
  }

  read(notification: SignNotificationItem): Observable<void> {
    this.popupIsOpen = false;
    this.refreshNotificationCount();
    return this.notificationService.setToRead(notification.id);
  }

  deleteAll(notification: SignNotificationItem[]): Observable<void> {
    this.refreshNotificationCount();
    return this.notificationService.deleteNotification(notification.map((n) => n.id));
  }

  getAll(): Observable<INotificationItem[]> {
    this.googleAnalitycsService.sendEvent(
          new TrackerData(
            AnalyticEventClient.TK_PT_SIGNER_GENERAL,
            'Signer_Geral_Notificação'
          )
        );
    return this.notificationService.get();
  }

  getSettings(): Observable<INotificationSettingForm[]> {
    return of([]);
  }

  saveSetting(nameProperty: string, value: boolean): Observable<void> {
    return of();
  }

  getNotificationCount(value?) {
    if(value !== null && value !== undefined){
      this.notificationService.onNotificationCounterChanged.emit(value);
    } else {
      this.notificationService.getCount().subscribe((data) => {
        this.notificationService.onNotificationCounterChanged.emit(data);
      });
    }
  }

  private refreshTotalUnread() {
    this.messageReceiveSubscription =
      this.notificationService.onNotificationCounterChanged.subscribe(
        (value) => (this.count = of(value)),
      );
  }

  private refreshNotificationCount() {
    setTimeout(() => {
      this.getNotificationCount();
    }, 500);
  }
}
